module.exports = __webpack_public_path__ + "static/offer-design-activity-b5e40db9ca27523d0d90fc016ae06c66.jpg";